if (process.env.REACT_APP_BUILD_TARGET === 'vk') {
  require('./index-vk-app');
} else {
  require('./index-web-app');
}

export default null;
